import {
  ReactElement,
  SyntheticEvent,
  EventHandler,
  MouseEventHandler,
  TouchEventHandler,
} from 'react';
import {useTouchDetector} from 'ui/effects/useTouchDetector';

interface ProviderProps {
  onPress: EventHandler<SyntheticEvent>;
  children?: (props: PressEventProps) => ReactElement;
}

export interface PressEventProps {
  onClick?: MouseEventHandler<HTMLElement>;
  onTouchEnd?: TouchEventHandler<HTMLElement>;
}

type PressEventProvider = (props: ProviderProps) => ReactElement;

export function CreatePressEventProvider(di: TouchDetectorDependencies = {}): PressEventProvider {
  return function ProviderComponent({children, onPress}: ProviderProps) {
    const supportsTouch = useTouchDetector(di);

    return children({
      onClick: !supportsTouch ? onPress : null,
      onTouchEnd: supportsTouch ? onPress : null,
    });
  };
}

export const PressEventProvider = CreatePressEventProvider();
